// extracted by mini-css-extract-plugin
export default {"statusIcon":"StatusIcons-module__statusIcon___kohzj"};